var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B657B994-375E-4F3A-8B10-8A497D9819B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-334.000000, -4988.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GoogleStorePublish",
    transform: "translate(334.000000, 4988.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "Google-Play-Copy-3",
    fontFamily: "Inter-Medium, Inter",
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: -0.548571416,
    fill: "#090F36"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 69
  }, "Google Play")), /*#__PURE__*/React.createElement("path", {
    d: "M40.9032878,29.0134398 C41.2730089,28.9652298 41.6479187,29.0475958 41.9638301,29.2464362 L52.734962,35.3958776 L50.0090371,38.1668708 L40.9032878,29.0134398 Z M40.0747392,29.8455699 C40.0227946,30.0267341 39.9976691,30.2145876 40.0001699,30.403097 L40.0001699,47.5949047 C39.9976691,47.7834141 40.0227946,47.9712676 40.0747392,48.1524319 L49.188774,38.9990009 L40.0747392,29.8455699 Z M50.0173226,39.831131 L40.9032878,48.984562 C41.2731839,49.0371359 41.6495739,48.9544446 41.9638301,48.7515655 L52.734962,42.6021242 L50.0173226,39.831131 Z M57.0765568,37.8839466 L53.8120752,36.0199751 L50.8293002,38.9990009 L53.8037898,41.9863479 L57.0682713,40.1223765 C58.1453845,39.5066002 58.1453845,38.4914015 57.0682713,37.8756253 L57.0765568,37.8839466 Z",
    id: "Shape",
    fill: "#090F36",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishGooglePlay);
export default __webpack_public_path__ + "static/media/PublishGooglePlay.6d121f3947eda5a70684c6655711d32b.svg";
export { ForwardRef as ReactComponent };